import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { colors, fontFamily, maxWidth } from "./tokens";
import Reveal from "./Reveal";

const useStyles = makeStyles(theme => ({
  section: {
    padding: theme.spacing(12, 3),
    background: colors.ink,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(8, 2.5)
    }
  },
  inner: {
    maxWidth,
    margin: "0 auto",
    textAlign: "center"
  },
  headline: {
    fontFamily,
    fontWeight: 700,
    letterSpacing: "-0.03em",
    fontSize: "clamp(1.75rem, 3.2vw, 2.75rem)",
    color: "#fff",
    margin: 0,
    marginBottom: theme.spacing(2)
  },
  sub: {
    fontFamily,
    fontSize: 15.5,
    lineHeight: 1.6,
    color: "rgba(255,255,255,0.65)",
    maxWidth: 480,
    margin: "0 auto",
    marginBottom: theme.spacing(5)
  },
  actions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "stretch"
    }
  },
  primaryBtn: {
    fontFamily,
    textTransform: "none",
    fontWeight: 600,
    fontSize: 15,
    borderRadius: 8,
    padding: theme.spacing(1.4, 3.5),
    backgroundColor: colors.primary,
    color: "#fff",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: colors.primaryDark,
      boxShadow: "none"
    }
  },
  secondaryBtn: {
    fontFamily,
    textTransform: "none",
    fontWeight: 600,
    fontSize: 15,
    borderRadius: 8,
    padding: theme.spacing(1.4, 3.5),
    border: "1px solid rgba(255,255,255,0.25)",
    color: "#fff",
    "&:hover": {
      background: "rgba(255,255,255,0.08)"
    }
  }
}));

export default function FinalCTA() {
  const classes = useStyles();

  return (
    <section className={classes.section}>
      <div className={classes.inner}>
        <Reveal as="h2" className={classes.headline}>
          Bring your maintenance operations together.
        </Reveal>
        <Reveal as="p" className={classes.sub} delay={60}>
          Everything you need to manage assets, maintenance and inventory -
          in one connected platform.
        </Reveal>
        <Reveal as="div" className={classes.actions} delay={120}>
          <Button className={classes.primaryBtn} href="/auth/registration">
            Get Started
          </Button>
          {/* <Button className={classes.secondaryBtn} href="/auth/login">
            Sign In
          </Button> */}
        </Reveal>
      </div>
    </section>
  );
}
